'use strict'
var fns = require('@tencent/fns')
function getParentNodes(node, _parents) {
	_parents =_parents || []
	var parent = node.parentNode
	if (!parent) { 
		return _parents 
	}
	_parents.push(parent)
    // end when match body
    if (parent === document.body) return _parents

	return getParentNodes(parent, _parents)
}
function isOverflow(node) {
    if (!node) return ''

    var style
    if (window.getComputedStyle) {
        try {
            style = window.getComputedStyle(node)
        } catch(e) {}
    } else if (node.currentStyle) {
        style = node.currentStyle
    }
    if (!style) return ''
    return getVisibleOverflow(style)
}
function isScrollElement(node) {
    if (node.hasAttribute && node.hasAttribute('_scroll_skip')) return false
    return /(auto|scroll)/.test(isOverflow(node)) || (node.hasAttribute && node.hasAttribute('_scroll_view'))
}
function getVisibleOverflow(style) {
    var overflow = ''
    fns.some(['-y', '-x', ''], function (k) {
        var name = 'overflow' + k
        var v = style[name] !== 'hidden' ? style[name] : ''
        if (v) {
            overflow = v
            return true
        }
    })
    return overflow
}
module.exports = function (node) {
	var parents = getParentNodes(node)
    var scrollParent = document.body
	for (var i = 0;i < parents.length;i ++) {
		var p = parents[i]
		if (p === document.body || isScrollElement(p)) {
			scrollParent = p
            break
		}
	}
	return {
        parents: parents,
        scrollParent: scrollParent
    }
}
